import React, { useRef, useState } from 'react';
import RecaptchaWidget from './RecaptchaWidget';
import WizardReviewBlock from './WizardReviewBlock';
import {
  getRecaptchaToken,
  RECAPTCHA_ERROR_MESSAGE,
  resetRecaptcha,
} from './recaptcha';

export default function WizardReviewStep({
  steps,
  fields,
  values,
  filesState,
  onEditStep,
  onBack,
  onSubmit,
  submitting,
  submitError,
  incompleteSteps,
  renderValue,
  recaptcha,
}) {
  const incomplete = incompleteSteps || [];
  const widgetRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [rendered, setRendered] = useState(false);
  const [recaptchaFailed, setRecaptchaFailed] = useState(false);
  const enabled = !!(recaptcha && recaptcha.enabled);

  const handleSubmit = () => {
    if (!enabled) {
      onSubmit(null);
      return;
    }
    setBusy(true);
    getRecaptchaToken(recaptcha, widgetRef.current)
      .then((token) => onSubmit(token))
      .catch(() => onSubmit(null, RECAPTCHA_ERROR_MESSAGE))
      .finally(() => {
        resetRecaptcha(widgetRef.current);
        setBusy(false);
      });
  };

  return (
    <section className="wizard-review">
      <h2>Review your submission</h2>
      {incomplete.length > 0 && (
        <div className="wizard-warning">
          Please complete the required fields in:{' '}
          {incomplete.map((step) => step.title).join(', ')}
        </div>
      )}
      {(steps || []).map((step, index) => (
        <WizardReviewBlock
          key={step.id}
          step={step}
          fields={fields}
          values={values}
          filesState={filesState}
          onEdit={() => onEditStep(index)}
          renderValue={(fieldId) => renderValue && renderValue(fieldId, step)}
        />
      ))}
      {submitError && <div className="wizard-error">{submitError}</div>}
      {enabled && recaptchaFailed && !submitError && (
        <div className="wizard-error">{RECAPTCHA_ERROR_MESSAGE}</div>
      )}
      {enabled && (
        <RecaptchaWidget
          config={recaptcha}
          onRendered={(widgetId) => {
            widgetRef.current = widgetId;
            setRendered(true);
            setRecaptchaFailed(false);
          }}
          onError={() => {
            setRecaptchaFailed(true);
            // A widget error can arrive while a submit is in flight (e.g. the
            // execute() promise never settles), so clear the busy state too.
            setBusy(false);
          }}
        />
      )}
      <div className="wizard-nav">
        <button type="button" onClick={onBack}>
          Back
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={
            submitting ||
            busy ||
            incomplete.length > 0 ||
            (enabled && !rendered && !recaptchaFailed)
          }
        >
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </section>
  );
}
